import { IRootScopeService } from "angular";
import { Ng1StateDeclaration } from "@uirouter/angularjs";
import { storage } from "@gtmhub/core/storage";
import { IUserMetadata } from "@gtmhub/login/models";
import { IUser } from "@gtmhub/users";
import { IProfile } from "@webapp/user-profile/models/user-profile.models";

export class UserProfileService {
  public static $inject = ["$rootScope"];

  constructor(private $rootScope: IRootScopeService) {}

  public getProfile(): IProfile {
    return storage.get<IProfile>("profile");
  }

  public setProfile(profile: IProfile, opts: { notify?: boolean } = {}): void {
    storage.set("profile", profile);

    if (opts.notify) {
      this.$rootScope.$broadcast("userProfileUpdated", profile);
    }
  }

  public clear(): void {
    storage.remove("profile");
  }

  public setProfileFromUser(user: IUser): void {
    const profile: IProfile = {
      email: user.email,
      isSSOBased: user.isSSOBased,
      isAzureIDPBased: user.isAzureIDPBased,
      identities: user.identities,
      firstName: user.firstName,
      lastName: user.lastName,
      avatar: user.avatar,
      picture: user.picture,
      created: user.dateCreated,
      language: user.language,
      isPrimary: user.isPrimary,
      pictureInfo: user.pictureInfo,
    };

    this.setProfile(profile);
  }

  public updateProfileNames(user: IUserMetadata): void {
    const profile = this.getProfile();
    if (user.firstName) {
      profile.firstName = user.firstName;
    }
    if (user.lastName) {
      profile.lastName = user.lastName;
    }

    this.setProfile(profile, { notify: true });
  }

  public demandsAreMet(toState: Ng1StateDeclaration): boolean {
    const stateRequiresAccount: boolean = toState && toState.data && toState.data.requiresAccount;
    const userProfile = this.getProfile();

    return !stateRequiresAccount || !!userProfile;
  }
}
